import { Link } from "gatsby"
import React from "react"
import "./work.scss"



class Work extends React.Component {
    render() {
        const {category, title, summary, src} = this.props;
        const titleLowCase = title.toLowerCase();

        return (
            <div id="work">
                    <p className="mobile">{summary}</p>
                    <div className="desc media">
                        <div className="category">
                            {category} 
                        </div>
                        <div className="title">
                            <span>:  </span>{title}
                            <p className="desk">{summary}</p>
                        </div>
                    </div>
                    
                    <div className="imgWrapper media">
                        <Link to={`/${titleLowCase}`}>
                        <img src={src} className="img" alt="img"/>
                        </Link>
                    </div>
                
            </div>
        )
    }
}

export default Work;